import { render, staticRenderFns } from "./DiscardDraftDialog.vue?vue&type=template&id=405973ea&scoped=true"
import script from "./DiscardDraftDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscardDraftDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DiscardDraftDialog.vue?vue&type=style&index=0&id=405973ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405973ea",
  null
  
)

export default component.exports